import { axiosClient, axiosClientAuth } from './axiosClient'

export const AUTH_LOCAL_STORAGE_KEY = 'goflipo-admin-token'
export const URLS_QUERY_KEY = 'urls-list'

export { axiosClient, axiosClientAuth }
